import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import {
	Popover,
	Tabs,
	Row,
	Modal,
	Button,
	Form,
	Input,
	Spin,
	Checkbox,
	Select,
	Switch,
	Table,
	Icon,
	Upload,
	AutoComplete,
	Col,
} from 'antd';
import {
	fetchSbt,
	editLawPlace,
	edit,
	save,
	deleteLawReport,
	toggleShowFullTextUpload,
	showNewLawplaceDialog,
	deleteAttachment,
	editCategoryPath,
	editCategoryDatabase,
	newCategoryPath,
	changeOrg,
	fetchSbtOrganization,
	setCategoryPaths,
	clearCategoryPath,
	clearLawplaces,
	setLawplaces,
	loadAutoCompleteCategories,
	filterCategories,
	editCategoryPathId,
} from './sbtActions';
import SbtLawplaceDialogComponent from './sbtLawplaceDialogComponent';
import { ENV, get_v2 } from '../utils/http';
import styles from './sbt.css';
import { formItemLayout, getRequiredRule, getDateRule } from '../utils/antUtils';
import { AiLayout } from '../components/ai/Layout';

const Option = Select.Option;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const { TextArea } = Input;
const Column = Table.Column;

class SbtComponent extends Component {
	state = {
		filteredOrganizations: [],
		filteredCategories: [],
		confirmDeleteVisible: false,
		databases: [],
		updateDBInitStateCompleted: false,
	};

	getDatabaseList = () => {
		get_v2('/databases/all').then((data) => {
			data = data.filter((db) => db.key !== 'Y');
			this.setState({ databases: data });
		});
	};

	componentDidMount() {
		if (this.props.match) {
			this.props.dispatch(fetchSbt(this.props.match.params.id));
		}

		if (this.props.allOrganizations.length === 0) {
			this.props.dispatch(fetchSbtOrganization());
		}

		this.getDatabaseList();
	}

	componentDidUpdate() {
		if (this.props.match && this.props.id != -1 && this.props.id != this.props.match.params.id) {
			this.props.dispatch(fetchSbt(this.props.match.params.id));
		}
	}

	shouldComponentUpdate(newProps) {
		if (newProps.selectedSbt > 0 && this.props.selectedSbt !== newProps.selectedSbt) {
			this.props.dispatch(fetchSbt(newProps.selectedSbt));
			return true;
		}

		return true;
	}

	showNewLawplaceDialog = () => {
		this.props.dispatch(showNewLawplaceDialog());
	};

	onChange(event, attr) {
		this.props.dispatch(edit(attr, event.target.value));
	}

	onChangeDate(momentValue, attr) {
		this.props.dispatch(edit(attr, momentValue));
	}

	onChangeValue(value, attr) {
		this.props.dispatch(edit(attr, value));

		if (attr === 'published' && value) {
			this.props.dispatch(edit('publicationDate', moment().format('YYYY-MM-DD')));
		}
	}

	onChangeCheckbox(value, attr) {
		this.props.dispatch(edit(attr, value));
	}

	onSelectCategory(value, option, index, attr) {
		let cat = this.props.autoCompleteCategories.find((c) => c.name === value);
		this.props.dispatch(editCategoryPathId(index, attr, value, cat ? cat.id : -1));
	}

	onChangeCategoryDatabase(event, index) {
		this.props.dispatch(editCategoryDatabase(index, event.target.value));
	}

	onChangeCategory(value, index, attr) {
		this.props.dispatch(editCategoryPath(index, attr, value));
	}

	onChangeLawPlace(event, index, attr) {
		this.props.dispatch(editLawPlace(index, attr, event.target.value));
	}

	onOrganizationFocus = () => {
		if (this.state.filteredOrganizations.length > 0) {
			this.setState({ filteredOrganizations: [] });
		}
	};

	onOrganizationSearch = (value) => {
		let lowerValue = value.toLowerCase();

		let filtered = this.props.allOrganizations.filter((org) => {
			return org.toLowerCase().indexOf(lowerValue) >= 0;
		});

		this.setState({
			filteredOrganizations: filtered.slice(0, 10),
		});
	};

	onCategoryFocus = (rowIndex, colIndex) => {
		let row = this.props.categoryPaths[rowIndex];
		let options = [];

		for (let i = 1; i <= colIndex; i++) {
			let categoryId = row[`category${colIndex}Id`];
			if (categoryId > 0) options.push(row[`category${colIndex}Id`]);
		}

		this.props.dispatch(loadAutoCompleteCategories(row.database, options, { rowIndex, colIndex }));
	};

	onCategorySearch = (value) => {
		let lowerValue = value.toLowerCase();

		let filtered = this.props.autoCompleteCategories.filter((cat) => {
			return cat.name.toLowerCase().indexOf(lowerValue) >= 0;
		});

		this.props.dispatch(filterCategories(filtered.map((f) => f.name)));
	};

	preview() {
		window.open(
			`${ENV.previewUrl}/rattsfall/${this.props.id}?previewKey=fa1853d6-e91c-11e8-9f32-f2801f1b9fd1`,
			'_blank'
		);
	}

	previewLawplace(index) {
		let lp = this.props.lawPlaces[index];
		window.open(
			`${ENV.previewUrl}/lag/${lp.sblDocumentId}?k=${lp.chapter || ''}&p=${lp.paragraph ||
				''}&r=${lp.additionalInformation || ''}`,
			'_blank'
		);
	}

	save() {
		let self = this;

		let hasPublished = !this.props.publishedOnLoad && this.props.published;

		let sbtType = this.props.originalFileName[0];
		let isNotLegalCase = sbtType === 'Z' || sbtType === '?' || sbtType === 'x' || sbtType === 'P';

		this.props.form.validateFields((errors) => {
			if (errors) {
				return false;
			}

			if (!hasPublished || isNotLegalCase) {
				return self.props.dispatch(save(self.props, false));
			}

			Modal.confirm({
				title: 'Rättsfallsbevakning',
				content:
					'Vill du skicka bevakningsnotiser till kunder som bevakar teman/lagrum associerade med detta rättsfall?',
				okText: 'Ja, spara och skicka',
				cancelText: 'Nej, bara spara',
				onOk() {
					self.props.dispatch(save(self.props, true));
				},
				onCancel() {
					self.props.dispatch(save(self.props, false));
				},
			});
		});
	}

	cloneCategoryPath(index) {
		this.props.dispatch(clearCategoryPath(index));
		let o = Object.assign({}, this.props.categoryPaths[index]);

		let categoryPaths = [
			...this.props.categoryPaths.slice(0, index),
			o,
			...this.props.categoryPaths.slice(index),
		];

		setTimeout(() => this.props.dispatch(setCategoryPaths(categoryPaths)), 0);
	}

	deleteCategoryPath(index) {
		this.props.dispatch(clearCategoryPath(index));
		let categoryPaths = [
			...this.props.categoryPaths.slice(0, index),
			...this.props.categoryPaths.slice(index + 1),
		];

		setTimeout(() => this.props.dispatch(setCategoryPaths(categoryPaths)), 0);
	}

	deleteLawplace(index) {
		this.props.dispatch(clearLawplaces(index));
		let lawPlaces = [
			...this.props.lawPlaces.slice(0, index),
			...this.props.lawPlaces.slice(index + 1),
		];

		setTimeout(() => this.props.dispatch(setLawplaces(lawPlaces)), 0);
	}

	cloneLawplace(index) {
		this.props.dispatch(clearLawplaces(index));
		let o = Object.assign({}, this.props.lawPlaces[index]);

		let lawPlaces = [
			...this.props.lawPlaces.slice(0, index),
			o,
			...this.props.lawPlaces.slice(index),
		];

		setTimeout(() => this.props.dispatch(setLawplaces(lawPlaces)), 0);
	}

	toggleDatabase = (attr, key, checked, publishOnStartPageTipsForDBsProperty) => {
		const updatedDatabases = [...this.state.databases];

		// Synchronize with the backend property publishOnStartPageTipsForDBsProperty the first time
		if (!this.state.updateDBInitStateCompleted) {
			if (publishOnStartPageTipsForDBsProperty) {
				Array.from(publishOnStartPageTipsForDBsProperty).forEach((element) => {
					const db = updatedDatabases.find((db) => db.key === element);

					if (db) {
						db.selected = true;
					}
				});
			}

			this.setState({ updateDBInitStateCompleted: true });
		}

		// Update currently clicked database checkbox state
		const index = updatedDatabases.findIndex((db) => db.key === key);
		updatedDatabases[index].selected = checked;

		// Update the internal state
		this.setState({ databases: updatedDatabases });

		let dbStrValue = '';
		updatedDatabases.forEach((element) => {
			if (element.selected) {
				dbStrValue += element.key;
			}
		});

		// Update the SBT property state (from databases object list --> string)
		this.props.dispatch(edit(attr, dbStrValue));
	};

	render() {
		const { getFieldDecorator } = this.props.form;

		const tailFormItemLayout = {
			wrapperCol: { xs: { span: 24, offset: 0 }, sm: { span: 16, offset: 8 } },
		};

		const textAreaRows = 25;

		const convertAttachmentToFileList = (attachments) => {
			if (!attachments) return [];

			return attachments.map((a) => ({
				uid: a.id,
				name: a.name,
				url: `${ENV.url}/attachment/${a.id}`,
				thumbUrl: '',
			}));
		};

		let { dispatch } = this.props;

		const uploadProps = {
			action: `${ENV.url}/admin/lawreports/attachments/upload?id=${this.props.id}`,
			className: 'upload-list-inline',
			onRemove(file) {
				dispatch(deleteAttachment(file.originFileObj ? file.originFileObj.uid : file.uid));
			},
			onPreview(file) {
				window.open(file.url || file.originFileObj.url, '_blank');
			},
			onChange(info) {
				if (info.file.status === 'done') {
					info.file.originFileObj.uid = info.file.response.id;
					info.file.url = `${ENV.url}/attachment/${info.file.response.id}`;
					info.file.originFileObj.url = `${ENV.url}/attachment/${info.file.response.id}`;
				}
			},
			defaultFileList: convertAttachmentToFileList(this.props.attachments),
		};

		const self = this;
		const uploadFulltextProps = {
			action: `${ENV.url}/admin/lawreports/fulltext/upload?id=${this.props.id}`,
			className: 'upload-list-inline',
			onRemove(file) {
				self.props.dispatch(toggleShowFullTextUpload(true));
				toggleShowFullTextUpload(true);
				dispatch(deleteAttachment(file.originFileObj ? file.originFileObj.uid : file.uid));
			},
			onPreview(file) {
				window.open(file.url || file.originFileObj.url, '_blank');
			},
			onChange(info) {
				if (info.file.status === 'done') {
					self.props.dispatch(toggleShowFullTextUpload(false));
					info.file.originFileObj.uid = info.file.response.id;
					info.file.url = `${ENV.url}/attachment/${info.file.response.id}`;
					info.file.originFileObj.url = `${ENV.url}/attachment/${info.file.response.id}`;
				}
			},
			defaultFileList: convertAttachmentToFileList(this.props.fullTextAttachments),
		};

		const categoryWidth = 190;

		let confirmPopup = (
			<div>
				<Button onClick={() => this.props.dispatch(deleteLawReport(this.props.id))}>Ja</Button>
				<Button
					style={{ marginLeft: 10 }}
					onClick={() => this.setState({ confirmDeleteVisible: false })}
				>
					Nej
				</Button>
			</div>
		);

		return (
			<Spin spinning={this.props.loading}>
				<div>
					<SbtLawplaceDialogComponent />
					<Row>
						<Button
							type='primary'
							style={{ float: 'right', marginTop: 10, zIndex: 100 }}
							size='large'
							onClick={() => this.save()}
						>
							Spara
						</Button>
						<Button
							icon='search'
							style={{
								float: 'right',
								marginTop: 10,
								marginRight: 10,
								zIndex: 100,
							}}
							size='large'
							type='secondary'
							onClick={() => this.preview()}
						>
							Förhandsgranska
						</Button>
						<Popover
							visible={this.state.confirmDeleteVisible}
							placement='topLeft'
							title={'Är du säker?'}
							content={confirmPopup}
							trigger='click'
						>
							<Button
								style={{
									float: 'right',
									marginTop: 10,
									marginRight: 10,
									zIndex: 100,
								}}
								size='large'
								type='danger'
								onClick={() => this.setState({ confirmDeleteVisible: true })}
							>
								Radera
							</Button>
						</Popover>
					</Row>

					<Row>
						<Tabs defaultActiveKey='1'>
							<TabPane tab='Grunduppgifter' key='1'>
								<Form onSubmit={this.handleSubmit} style={{ maxWidth: 700 }}>
									<FormItem {...tailFormItemLayout}>
										<Switch
											checked={this.props.published}
											checkedChildren='Publicerad'
											unCheckedChildren='Ej publicerad'
											style={{
												float: 'right',
												marginTop: 20,
												marginRight: 10,
												zIndex: 1000,
											}}
											onChange={(e) => this.onChangeValue(e, 'published')}
										/>
									</FormItem>

									<FormItem {...formItemLayout} label='Databaser för okommenterad pdf'>
										{getFieldDecorator('baseDbType')(
											<Input onBlur={(e) => this.onChange(e, 'baseDbType')} />
										)}
									</FormItem>

									<FormItem {...tailFormItemLayout}>
										{getFieldDecorator('sbtPlus', {
											valuePropName: 'checked',
										})(
											<Checkbox
												onChange={(e) => this.onChangeCheckbox(e.target.checked, 'sbtPlus')}
											>
												Rättsfall +
											</Checkbox>
										)}
									</FormItem>

									<FormItem {...formItemLayout} label='Publiceringsdatum'>
										{getFieldDecorator('publicationDate', {
											rules: [
												getDateRule('Ange ett giltigt introduktionsdatum på formatet: 2017-12-24'),
											],
										})(<Input onBlur={(e) => this.onChange(e, 'publicationDate')} />)}
									</FormItem>

									<FormItem {...formItemLayout} label='Filnamn'>
										{getFieldDecorator('originalFileName', {
											rules: [getRequiredRule('Ange ett filnamn')],
										})(<Input onBlur={(e) => this.onChange(e, 'originalFileName')} />)}
									</FormItem>
									<FormItem {...formItemLayout} label='Källa'>
										{getFieldDecorator('sourceId', {
											rules: [getRequiredRule('Ange en källa')],
										})(
											<Select
												style={{ width: '100%' }}
												showSearch
												optionFilterProp='children'
												onChange={(e) => this.onChangeValue(e, 'sourceId')}
											>
												{this.props.sources.map((s) => (
													<Option key={s.id} value={s.id}>
														{s.fullName} &gt; {s.id}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem {...formItemLayout} label='Mål/Diarienr'>
										{getFieldDecorator('caseNumber', { rules: [] })(
											<Input onBlur={(e) => this.onChange(e, 'caseNumber')} />
										)}
									</FormItem>
									<FormItem {...formItemLayout} label='Faktiskt mål nr'>
										{getFieldDecorator('actualCaseNumber', { rules: [] })(
											<Input onBlur={(e) => this.onChange(e, 'actualCaseNumber')} />
										)}
									</FormItem>

									<FormItem {...formItemLayout} label='Publikation'>
										{getFieldDecorator('source', { rules: [] })(
											<Input onBlur={(e) => this.onChange(e, 'source')} />
										)}
									</FormItem>
									<FormItem {...formItemLayout} label='Beslutsdatum'>
										{getFieldDecorator('decisionDate', {
											rules: [
												getRequiredRule('Ange ett beslutdatum'),
												getDateRule('Ange ett giltigt beslutdatum på formatet: 2017-12-24'),
											],
										})(<Input onBlur={(e) => this.onChange(e, 'decisionDate')} />)}
									</FormItem>
									<FormItem {...formItemLayout} label='Introduktionsdatum'>
										{getFieldDecorator('introductionDate', {
											rules: [
												getRequiredRule('Ange ett introduktionsdatum'),
												getDateRule('Ange ett giltigt introduktionsdatum på formatet: 2017-12-24'),
											],
										})(<Input onBlur={(e) => this.onChange(e, 'introductionDate')} />)}
									</FormItem>

									<FormItem {...tailFormItemLayout}>
										{getFieldDecorator('publishOnStartPage', {
											valuePropName: 'checked',
										})(
											<Checkbox
												onChange={(e) =>
													this.onChangeCheckbox(e.target.checked, 'publishOnStartPage')
												}
											>
												Publicerad på startsidan
											</Checkbox>
										)}
									</FormItem>

									<FormItem {...formItemLayout} label='Titel på startsidan'>
										{getFieldDecorator('startPageTitle', { rules: [] })(
											<Input onBlur={(e) => this.onChange(e, 'startPageTitle')} />
										)}
									</FormItem>
									<FormItem {...formItemLayout} label='Domstol'>
										{getFieldDecorator('court', { rules: [] })(
											<Input onBlur={(e) => this.onChange(e, 'court')} />
										)}
									</FormItem>
								</Form>
								<div style={{ minWidth: 900 }}>
									<div style={styles.organizationLabel}>Organisationer:</div>
									<div style={styles.organizationInputs}>
										{this.props.organizations.map((org, index) => (
											<AutoComplete
												key={index}
												style={{ width: 463 }}
												onSearch={this.onOrganizationSearch}
												dataSource={this.state.filteredOrganizations}
												defaultValue={org}
												onFocus={this.onOrganizationFocus}
												onChange={(value) => this.props.dispatch(changeOrg(index, value))}
											/>
										))}
									</div>
								</div>
							</TabPane>
							<TabPane tab='Teman' key='2'>
								<Table
									className='small-padding-table'
									dataSource={this.props.categoryPaths}
									pagination={false}
									size='small'
									footer={() => (
										<Button onClick={() => this.props.dispatch(newCategoryPath())} icon='plus'>
											Lägg till fler
										</Button>
									)}
								>
									<Column
										title='Databas'
										width={100}
										dataIndex='database'
										key='database'
										render={(value, record, index) => (
											<Input
												style={{ width: 100 }}
												onChange={(e) => this.onChangeCategoryDatabase(e, index)}
												defaultValue={value}
											></Input>
										)}
									/>
									<Column
										title='Tema 1'
										width={categoryWidth}
										dataIndex='category1'
										key='category1'
										render={(value, record, index) => (
											<AutoComplete
												style={{ width: categoryWidth }}
												onSearch={this.onCategorySearch}
												onSelect={(value, option) =>
													this.onSelectCategory(value, option, index, 'category1')
												}
												dataSource={this.props.filteredAutoCompleteCategories}
												defaultValue={value}
												onFocus={() => this.onCategoryFocus(index, 0)}
												onChange={(e) => this.onChangeCategory(e, index, 'category1')}
											/>
										)}
									/>
									<Column
										title='Tema 2'
										width={categoryWidth}
										dataIndex='category2'
										key='category2'
										render={(value, record, index) => (
											<AutoComplete
												style={{ width: categoryWidth }}
												onSearch={this.onCategorySearch}
												onSelect={(value, option) =>
													this.onSelectCategory(value, option, index, 'category2')
												}
												dataSource={this.props.filteredAutoCompleteCategories}
												defaultValue={value}
												onFocus={() => this.onCategoryFocus(index, 1)}
												onChange={(e) => this.onChangeCategory(e, index, 'category2')}
											/>
										)}
									/>
									<Column
										title='Tema 3'
										width={categoryWidth}
										dataIndex='category3'
										key='category3'
										render={(value, record, index) => (
											<AutoComplete
												style={{ width: categoryWidth }}
												onSearch={this.onCategorySearch}
												onSelect={(value, option) =>
													this.onSelectCategory(value, option, index, 'category3')
												}
												dataSource={this.props.filteredAutoCompleteCategories}
												defaultValue={value}
												onFocus={() => this.onCategoryFocus(index, 2)}
												onChange={(e) => this.onChangeCategory(e, index, 'category3')}
											/>
										)}
									/>
									<Column
										title='Tema 4'
										width={categoryWidth}
										dataIndex='category4'
										key='category4'
										render={(value, record, index) => (
											<AutoComplete
												style={{ width: categoryWidth }}
												onSearch={this.onCategorySearch}
												onSelect={(value, option) =>
													this.onSelectCategory(value, option, index, 'category4')
												}
												dataSource={this.props.filteredAutoCompleteCategories}
												defaultValue={value}
												onFocus={() => this.onCategoryFocus(index, 3)}
												onChange={(e) => this.onChangeCategory(e, index, 'category4')}
											/>
										)}
									/>
									<Column
										width={70}
										title='Radera'
										key='del'
										render={(v, r, index) => (
											<Icon
												style={styles.tableIcon}
												type='delete'
												onClick={() => this.deleteCategoryPath(index)}
											/>
										)}
									/>
									<Column
										title='Kopiera'
										key='clone'
										render={(v, r, index) => (
											<Icon
												style={styles.tableIcon}
												type='copy'
												onClick={() => this.cloneCategoryPath(index)}
											/>
										)}
									/>
								</Table>
							</TabPane>
							<TabPane tab='Sammanfattning' key='3'>
								<div style={{ display: 'flex', columnGap: '10px' }}>
									<FormItem style={{ flexGrow: 1 }}>
										{getFieldDecorator('preamble')(
											<TextArea
												style={styles.textArea}
												rows={textAreaRows}
												onBlur={(e) => this.onChange(e, 'preamble')}
											/>
										)}
									</FormItem>
								</div>
							</TabPane>
							<TabPane tab='Kommentar' key='4'>
								<FormItem>
									{getFieldDecorator('content')(
										<TextArea
											style={styles.textArea}
											rows={textAreaRows}
											onBlur={(e) => this.onChange(e, 'content')}
										/>
									)}
								</FormItem>
							</TabPane>
							<TabPane tab='Fulltext' key='5'>
								{!this.props.loading && (
									<Upload {...uploadFulltextProps}>
										{this.props.showFullTextUpload && (
											<Button>
												<Icon type='upload' /> Ladda upp fulltext PDF
											</Button>
										)}
									</Upload>
								)}

								{this.props.showFullTextUpload && (
									<FormItem style={{ marginTop: 20 }}>
										{getFieldDecorator('fullText')(
											<TextArea
												style={styles.textArea}
												rows={textAreaRows}
												onBlur={(e) => this.onChange(e, 'fullText')}
											/>
										)}
									</FormItem>
								)}
							</TabPane>
							<TabPane tab='Lagrum' key='6'>
								<Table
									className='small-padding-table'
									dataSource={this.props.lawPlaces}
									pagination={false}
									size='small'
									footer={() => (
										<Button onClick={this.showNewLawplaceDialog} icon='plus'>
											Lägg till fler
										</Button>
									)}
								>
									<Column title='Författning' dataIndex='sblDescription' key='sblDescription' />
									<Column title='Nr' width={150} dataIndex='sfsNumber' key='sfsNumber' />
									<Column
										title='Kapitel'
										width={100}
										dataIndex='chapter'
										key='chapter'
										render={(value, record, index) => (
											<Input
												onChange={(e) => this.onChangeLawPlace(e, index, 'chapter')}
												defaultValue={value}
											></Input>
										)}
									/>
									<Column
										title='Paragraf'
										width={100}
										dataIndex='paragraph'
										key='paragraph'
										render={(value, record, index) => (
											<Input
												onChange={(e) => this.onChangeLawPlace(e, index, 'paragraph')}
												defaultValue={value}
											></Input>
										)}
									/>
									<Column
										title='Övrigt'
										width={100}
										dataIndex='additionalInformation'
										key='additionalInformation'
										render={(value, record, index) => (
											<Input
												onChange={(e) => this.onChangeLawPlace(e, index, 'additionalInformation')}
												defaultValue={value}
											></Input>
										)}
									/>
									<Column
										width={70}
										title='Kopiera'
										key='action1'
										render={(v, r, index) => (
											<Icon
												style={styles.tableIcon}
												type='copy'
												onClick={() => this.cloneLawplace(index)}
											/>
										)}
									/>
									<Column
										width={70}
										title='Radera'
										key='action2'
										render={(v, r, index) => (
											<Icon
												style={styles.tableIcon}
												type='delete'
												onClick={() => this.deleteLawplace(index)}
											/>
										)}
									/>
									<Column
										title='Testa'
										key='action3'
										render={(v, r, index) => (
											<Icon
												style={styles.tableIcon}
												type='link'
												onClick={() => this.previewLawplace(index)}
											/>
										)}
									/>
								</Table>
							</TabPane>
							<TabPane tab='Bilagor' key='7'>
								{!this.props.loading && (
									<Upload {...uploadProps}>
										<Button>
											<Icon type='upload' /> Ladda upp
										</Button>
									</Upload>
								)}
							</TabPane>
							<TabPane tab='Juristen tipsar' key='8'>
								<div style={{ maxWidth: 700 }}>
									<FormItem {...tailFormItemLayout}>
										{getFieldDecorator('publishOnStartPageTips', {
											valuePropName: 'checked',
										})(
											<Checkbox
												onChange={(e) =>
													this.onChangeCheckbox(e.target.checked, 'publishOnStartPageTips')
												}
											>
												Visa under Juristen tipsar
											</Checkbox>
										)}
									</FormItem>
									<FormItem {...formItemLayout} label='Tipsdatum'>
										{getFieldDecorator('publishOnStartPageTipsDate', {
											rules: [getDateRule('Ange ett giltigt datum på formatet: 2017-12-24')],
										})(<Input onBlur={(e) => this.onChange(e, 'publishOnStartPageTipsDate')} />)}
									</FormItem>

									<FormItem {...formItemLayout} label='Tipsrubrik'>
										{getFieldDecorator('publishOnStartPageTipsTitle', {
											rules: [],
										})(<Input onBlur={(e) => this.onChange(e, 'publishOnStartPageTipsTitle')} />)}
									</FormItem>

									<FormItem {...formItemLayout} label='Databaser'>
										<Row>
											{this.props.categoryPaths &&
												this.props.categoryPaths.length > 0 &&
												this.state.databases
													.filter((database) =>
														this.props.categoryPaths
															.map((item) => item.database)
															.join('') // Concatenate all theme database inputs
															.split('') // Split the string into an array of characters
															.includes(database.key)
													)
													.map((db, index) => {
														let checked = db.selected;

														if (this.props.publishOnStartPageTipsForDBs) {
															checked =
																this.props.publishOnStartPageTipsForDBs.indexOf(db.key) != -1;
														}

														return (
															<Col span={12} key={index}>
																<Checkbox
																	checked={checked}
																	onChange={(e) =>
																		this.toggleDatabase(
																			'publishOnStartPageTipsForDBs',
																			db.key,
																			e.target.checked,
																			this.props.publishOnStartPageTipsForDBs
																		)
																	}
																	value={db.name}
																>
																	{db.name}
																</Checkbox>
															</Col>
														);
													})}
										</Row>
									</FormItem>
								</div>
							</TabPane>
							<TabPane tab='AI Verktyg' key='9'>
								<AiLayout
									prefill={[
										{ key: 'Kommentar', value: this.props.content },
										{ key: 'Fulltext', value: this.props.fullText },
									]}
								/>
							</TabPane>
						</Tabs>
					</Row>
				</div>
			</Spin>
		);
	}
}

const mapStateToProps = (state) => ({
	id: state.sbt.id,
	originalFileName: state.sbt.originalFileName,
	caseNumber: state.sbt.caseNumber,
	actualCaseNumber: state.sbt.actualCaseNumber,
	sourceId: state.sbt.sourceId,
	source: state.sbt.source,
	decisionDate: state.sbt.decisionDate,
	introductionDate: state.sbt.introductionDate,
	publicationDate: state.sbt.publicationDate,
	organizations: state.sbt.organizations,
	published: state.sbt.published,
	preamble: state.sbt.preamble,
	content: state.sbt.content,
	fullText: state.sbt.fullText,
	sources: state.sbt.sources,
	loading: state.sbt.loading,
	lawPlaces: state.sbt.lawPlaces,
	hasChanges: state.sbt.hasChanges,
	showNewLawplaceDialog: state.sbt.showNewLawplaceDialog,
	selectedSbt: state.lawreport.selectedSbt,
	attachments: state.sbt.attachments,
	fullTextAttachments: state.sbt.fullTextAttachments,
	allOrganizations: state.sbt.allOrganizations,
	categoryPaths: state.sbt.categoryPaths,
	autoCompleteCategories: state.sbt.autoCompleteCategories,
	filteredAutoCompleteCategories: state.sbt.filteredAutoCompleteCategories,
	startPageTitle: state.sbt.startPageTitle,
	publishOnStartPageTipsTitle: state.sbt.publishOnStartPageTipsTitle,
	publishOnStartPageTipsDate: state.sbt.publishOnStartPageTipsDate,
	publishOnStartPageTipsForDBs: state.sbt.publishOnStartPageTipsForDBs,
	court: state.sbt.court,
	publishOnStartPage: state.sbt.publishOnStartPage,
	publishOnStartPageTips: state.sbt.publishOnStartPageTips,
	publishedOnLoad: state.sbt.publishedOnLoad,
	baseDbType: state.sbt.baseDbType,
	showFullTextUpload: state.sbt.showFullTextUpload,
	sbtPlus: state.sbt.sbtPlus,
});

export default connect(mapStateToProps)(
	Form.create({
		mapPropsToFields(props) {
			return {
				published: Form.createFormField({ value: props.published }),
				originalFileName: Form.createFormField({
					value: props.originalFileName,
				}),
				sourceId: Form.createFormField({ value: props.sourceId }),
				caseNumber: Form.createFormField({ value: props.caseNumber }),
				actualCaseNumber: Form.createFormField({
					value: props.actualCaseNumber,
				}),
				source: Form.createFormField({ value: props.source }),
				decisionDate: Form.createFormField({ value: props.decisionDate }),
				introductionDate: Form.createFormField({
					value: props.introductionDate,
				}),
				publicationDate: Form.createFormField({ value: props.publicationDate }),
				preamble: Form.createFormField({ value: props.preamble }),
				content: Form.createFormField({ value: props.content }),
				fullText: Form.createFormField({ value: props.fullText }),
				startPageTitle: Form.createFormField({ value: props.startPageTitle }),

				court: Form.createFormField({ value: props.court }),
				publishOnStartPage: Form.createFormField({
					value: props.publishOnStartPage,
				}),
				publishOnStartPageTips: Form.createFormField({
					value: props.publishOnStartPageTips,
				}),
				publishOnStartPageTipsTitle: Form.createFormField({
					value: props.publishOnStartPageTipsTitle,
				}),
				publishOnStartPageTipsDate: Form.createFormField({
					value: props.publishOnStartPageTipsDate,
				}),
				publishOnStartPageTipsForDBs: Form.createFormField({
					value: props.publishOnStartPageTipsForDBs,
				}),
				baseDbType: Form.createFormField({ value: props.baseDbType }),
				sbtPlus: Form.createFormField({ value: props.sbtPlus }),
			};
		},
	})(SbtComponent)
);



// WEBPACK FOOTER //
// ./src/sbt/sbtComponent.js